import React, { useEffect, useState } from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import { CiCamera } from "react-icons/ci";
import { FaEdit } from "react-icons/fa";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { BsThreeDots } from "react-icons/bs";
import { FaThumbsUp, FaBell, FaShareAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import uploadFiles from "../common/UploadFiles";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const Banner = ({ profiledate }) => {
  // console.log(profiledate);
  const [backgroundprofile, setBackgroundprofile] = useState(
    "/image/backgroundprofile.png"
  );
  const [profilePreview, setProfilePreview] = useState("/image/profilepic.png");
  const [coverFile, setCoverFile] = useState(null);

  useEffect(() => {
    if (profiledate?.cover_image?.url) {
      setBackgroundprofile(profiledate.cover_image.url);
    }
    if (profiledate?.profile_image?.url) {
      setProfilePreview(profiledate.profile_image.url);
    }
  }, [profiledate]);

  const handleImageUpload = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ show preview
    const previewUrl = URL.createObjectURL(file);
    if (fieldName === "cover_image") {
      setBackgroundprofile(previewUrl);
    } else if (fieldName === "profile_image") {
      setProfilePreview(previewUrl);
    }

    try {
      // ✅ upload file
      const uploaded = await uploadFiles([file]);
      const imageData = {
        url: uploaded[0].url,
        media_type: file.type,
      };

      // ✅ send dynamic body
      const body = {
        seller_id: String(profiledate?.id),
        [fieldName]: imageData,
      };

      const resp = await axios.post(
        `${API_BASE_URL}/seller/update-seller-profile`,
        body,
        {
          headers: {
            token:
              sessionStorage.getItem("accessToken") ||
              localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );
      console.log(`${fieldName} updated:`, resp);

      toast.success(
        `${
          fieldName === "cover_image" ? "Cover" : "Profile"
        } image updated successfully!`
      );
    } catch (error) {
      console.error(`Error uploading ${fieldName}:`, error);
      toast.error(`Failed to upload ${fieldName.replace("_", " ")}!`);
    }
  };
  return (
    <div className="relative rounded-lg py-4">
      {/* Cover Photo */}
      <div className="w-full h-[100px] sm:h-[320px] rounded-lg overflow-hidden relative group">
        <input
          type="file"
          accept="image/*"
          id="cover-upload"
          className="hidden"
          onChange={(e) => handleImageUpload(e, "cover_image")}
        />
        <label className="cursor-pointer block">
          <img
            src={backgroundprofile}
            alt="Cover"
            className="w-full h-[100px] sm:h-[280px] object-cover group-hover:opacity-80 transition"
          />
        </label>
        <div className="absolute top-0 right-10 bg-white px-2 py-2 text-sm rounded-b-2xl shadow">
          {/* <span className="flex items-center gap-2">
            <FaEdit className="text-lg" />
            Edit Cover
          </span> */}
        </div>
      </div>

      {/* Profile Image & Info */}
      <div className="absolute -bottom-7 left-3 sm:-bottom-9 sm:left-6 flex w-[95%] justify-between items-end">
        <div className="flex items-center">
          {/* Profile Photo */}
          <div className="relative w-[70px] h-[70px] sm:w-[170px] sm:h-[170px] overflow-hidden group">
            <input
              type="file"
              accept="image/*"
              id="profile-upload"
              className="hidden"
              onChange={(e) => handleImageUpload(e, "profile_image")}
            />
            <label htmlFor="profile-upload" className="cursor-pointer block">
              <img
                src={profilePreview}
                alt="Profile"
                className="w-[70px] h-[70px] sm:w-full sm:h-full object-cover group-hover:opacity-80 transition"
              />
            </label>
            {/* <div className="absolute top-[50%] right-0 bg-transparent text-xs px-1 py-1 rounded shadow">
              <CiCamera className="text-xl text-white" />
            </div> */}
          </div>

          <div className="mt-20 ml-7">
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-3">
                <p className="text-lg font-semibold">
                  {profiledate?.name || "Unknown User"}{" "}
                </p>
                <p className="flex items-center text-[12px] text-white bg-green-400 p-1 rounded-xl">
                  <RiVerifiedBadgeFill />
                  Verified
                </p>
              </div>
              <p className="text-[#929292]">@{profiledate?.store_name}</p>

              {/* <div className="flex items-center ">
                <div className="flex -space-x-3">
                  <img
                    src="/image/indidvilesell.png"
                    className="w-8 h-8 rounded-full border-2 border-white shadow-md"
                  />
                  <img
                    src="/image/profilepic.png"
                    className="w-8 h-8 rounded-full border-2 border-white shadow-md"
                  />
                  <img
                    src="/image/sharebuttoncontainer.png"
                    className="w-8 h-8 rounded-full border-2 border-white shadow-md"
                  />
                  <img
                    src="/image/PostInputImage.png"
                    className="w-8 h-8 rounded-full border-2 border-white shadow-md"
                  />
                </div>
                <div className="ml-2 text-green-800 font-semibold text-[12px]">
                  35,52,22 Likes
                </div>
              </div> */}
            </div>
          </div>
        </div>

        {/* RIGHT SIDE ACTION BUTTONS */}
        {/* <div className="hidden sm:flex items-center gap-3 mb-5">
          <button className="px-3 py-1 border border-cyan-400 text-cyan-600 rounded-full hover:bg-cyan-100 transition text-sm flex items-center gap-1">
            <FaThumbsUp className="text-cyan-500" />
            Like
          </button>
          <button className="p-2 bg-green-900 rounded-full text-white">
            <FaShareAlt />
          </button>
          <button className="p-2 bg-green-900 rounded-full text-white">
            <FaBell />
          </button>
          <button className="p-2 bg-green-900 rounded-full text-white">
            <BsThreeDots />
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Banner;
